import magnifiAPIInstance from "./apiInstance";

export const ruleConfigurationV2APIs = {
  getFilterTemplates: ({ payload }) =>
    magnifiAPIInstance.get("api/v4/rules/filter-templates", {
      params: payload,
    }),
  createV2RuleConfiguration: ({ payload, entityId }) =>
    magnifiAPIInstance.post(`/api/v4/entities/${entityId}/rules`, payload),
  updateV2RuleConfiguration: ({ payload, entityId, ruleId }) =>
    magnifiAPIInstance.put(`/api/v4/entities/${entityId}/rules/${ruleId}`, payload),
  getV2RuleConfiguration: ({ entityId, ruleId }) =>
    magnifiAPIInstance.get(`/api/v4/entities/${entityId}/rules/${ruleId}`),
  getFilterTemplateById: ({ templateId }) => magnifiAPIInstance.get(`/api/v4/rules/filter-templates/${templateId}`),
  listRuleGeneratedContent: ({ payload, entityId, ruleId }) =>
    magnifiAPIInstance.get(`/api/v4/entities/${entityId}/rules.generated/${ruleId}`, payload),
};
